import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  GET_POESIA_ID,
  GET_POESIAS,
  SEARCH_POESIAS,
  REMOVE_POESIA,
} from '../../graphql/actions/poesia';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Subject from '@material-ui/icons/Subject';
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import Order from '../Order/Order';
import Filter from '../Filter/Filter';
import Limit from '../Limit/Limit';
import Paginate from '../Paginate/Paginate';
import Total from '../Total/Total';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import PoesiaDel from './PoesiaDel';

import sectionDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDataStyle';

const useStyles = makeStyles(sectionDataStyle);

const PoesiaData = (props) => {
  const classes = useStyles();
  const [numPoesias, setNumPoesias] = useState(9);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [search, setSearch] = useState('');
  const [eliminarPoesiaModal, setEliminarPoesiaModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_POESIA_ID,
      data: { getPoesiaId: id },
    });
    setEliminarPoesiaModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarPoesiaModal(false);
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removePoesia) setEliminarPoesiaModal(false);
    else console.log('Error eliminando poesía.');
  };

  const updateCacheDel = (cache, id) => {
    const { getPoesias } = cache.readQuery({
      query: GET_POESIAS,
      variables: {
        paginate: {
          numPoesias: numPoesias,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevaPoesias = getPoesias.poesias.filter(
      (poesia) => poesia.id !== id
    );

    if (getPoesias && nuevaPoesias) {
      cache.writeQuery({
        query: GET_POESIAS,
        variables: {
          paginate: {
            numPoesias: numPoesias,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getPoesias: {
            poesias: nuevaPoesias,
          },
        },
      });
    }
  };

  const {
    loading: loadingPoesias,
    error: errorPoesias,
    data: dataPoesias,
    fetchMore,
  } = useQuery(GET_POESIAS, {
    variables: {
      paginate: {
        numPoesias: numPoesias,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [executeSearch, { loading: loadingSearch, data: dataSearch }] =
    useLazyQuery(SEARCH_POESIAS, {
      errorPolicy: 'all',
    });

  const [
    eliminarPoesia,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_POESIA, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const onSearchHandler = (event) => {
    event.preventDefault();
    executeSearch({
      variables: {
        paginate: {
          numPoesias: numPoesias,
          cursor: '',
          query: search,
          sortBy: { field: field, order: order },
        },
      },
    });
  };

  const removePoesiaHandler = (id) => {
    eliminarPoesia({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  const numPoesiasChangedHandler = (event) => {
    if (event.target.name === 'numComponentes')
      setNumPoesias(event.target.value);
  };

  const fieldChangedHandler = (event) => {
    if (event.target.name === 'field') setField(event.target.value);
  };

  const orderChangedHandler = (event) => {
    if (event.target.name === 'order') setOrder(event.target.value);
  };

  const searchChangedHandler = (event) => {
    if (event.target.name === 'search') setSearch(event.target.value);
  };

  const onPaginationHandler = (cursor) => {
    fetchMore({
      variables: {
        paginate: {
          numPoesias: numPoesias,
          cursor: cursor,
          sortBy: { field: field, order: order },
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        fetchMoreResult.getPoesias.poesias = [
          ...prev.getPoesias.poesias,
          ...fetchMoreResult.getPoesias.poesias,
        ];
        return fetchMoreResult;
      },
    });
  };

  let showNotification = null;
  let seccionTitulo = null;
  let seccionOrderFilter = null;
  let seccionCardPoesia = null;
  let seccionBotonAdd = null;
  let seccionLimitPagination = null;
  let seccionTotal = null;
  let removeModal = (
    <PoesiaDel
      show={eliminarPoesiaModal}
      close={eliminarCloseModalHandler}
      removePoesia={removePoesiaHandler}
    />
  );

  if (loadingPoesias) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;
  if (loadingSearch) {
    seccionOrderFilter = (
      <div id='orderandfilter' className={classes.marginBottom20}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <Order />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorPoesias) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>
              Error al buscar las poesías en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionOrderFilter = null;
    seccionCardPoesia = null;
    seccionBotonAdd = null;
    seccionLimitPagination = null;
    seccionTotal = null;

    showNotification = errorPoesias.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorPoesias ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataPoesias && dataPoesias.getPoesias) {
    const { getPoesias } = dataPoesias;
    //console.log(getPoesias);
    if (getPoesias.poesias.length === 0) {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron poesías, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = null;
      seccionCardPoesia = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'poesía'} />
        </div>
      ) : null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>Poesías</h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'poesía'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardPoesia = (
        <GridContainer>
          {getPoesias.poesias.map((poesia) => (
            <GridItem xs={12} sm={4} md={4} key={poesia.node._id}>
              <Card color='dark' key={poesia.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {poesia.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {poesia.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/poesía/' + poesia.node._id);
                        }}
                      >
                        <Subject />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-poesía/' + poesia.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(poesia.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/poesía/' + poesia.node._id);
                        }}
                      >
                        Leer Poesía
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'poesía'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numPoesias}
                numdComponentesChange={numPoesiasChangedHandler}
                nombreComponente={'Poesías'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={getPoesias.pageInfo.startCursor}
                cursorFinal={getPoesias.pageInfo.endCursor}
                tienePaginaSiguiente={getPoesias.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={getPoesias.totalCount}
            nombreComponente={'Poesías'}
          />
        </div>
      );
    }
  }

  if (dataSearch && dataSearch.searchPoesias) {
    const { searchPoesias } = dataSearch;

    if (searchPoesias.poesias.length === 0) {
      seccionTitulo = null;

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}></GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'poesía'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardPoesia = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron poesías en la busqueda.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionBotonAdd = null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'poesía'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardPoesia = (
        <GridContainer>
          {searchPoesias.poesias.map((poesia) => (
            <GridItem xs={12} sm={4} md={4} key={poesia.node._id}>
              <Card color='dark' key={poesia.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {poesia.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {poesia.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/poesía/' + poesia.node._id);
                        }}
                      >
                        <Subject />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-poesía/' + poesia.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(poesia.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push('/poesía/' + poesia.node._id);
                        }}
                      >
                        Leer Poesía
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'poesía'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numPoesias}
                numdComponentesChange={numPoesiasChangedHandler}
                nombreComponente={'Poesías'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={searchPoesias.pageInfo.startCursor}
                cursorFinal={searchPoesias.pageInfo.endCursor}
                tienePaginaSiguiente={searchPoesias.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={searchPoesias.totalCount}
            nombreComponente={'Poesías'}
          />
        </div>
      );
    }
  }

  if (dataRemove && dataRemove.removePoesia) {
    const { removePoesia } = dataRemove;
    if (removePoesia.success && removePoesia.code === '200') {
      showNotification = (
        <Notification
          key={removePoesia.code}
          mostrar={removePoesia.success ? true : false}
          msg={removePoesia.message}
          stt={removePoesia.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionOrderFilter}
              {seccionCardPoesia}
              {seccionBotonAdd}
              {seccionLimitPagination}
              {seccionTotal}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(PoesiaData);
